export default __webpack_public_path__ + "static/media/168587773.ca8dcc64.svg";